var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 0.833313C7.11925 11.8291 0.666748 21.3266 0.666748 29.35C0.666748 41.385 9.85008 49.1666 20.0001 49.1666C30.1501 49.1666 39.3334 41.385 39.3334 29.35C39.3334 21.3266 32.8809 11.8291 20.0001 0.833313ZM20.0001 44.3333C11.9042 44.3333 5.50008 38.1225 5.50008 29.35C5.50008 23.695 10.2126 16.2033 20.0001 7.26165C29.7876 16.2033 34.5001 23.6708 34.5001 29.35C34.5001 38.1225 28.0959 44.3333 20.0001 44.3333ZM9.92258 29.8333C10.8167 29.8333 11.5417 30.4616 11.7109 31.3316C12.7017 36.6966 17.2209 38.5333 20.5076 38.2675C21.5467 38.2191 22.4167 39.0408 22.4167 40.08C22.4167 41.0466 21.6434 41.8441 20.6767 41.8925C15.5292 42.2066 9.51175 39.2583 8.13425 31.9358C8.09225 31.6767 8.10703 31.4116 8.17757 31.1587C8.2481 30.9059 8.37271 30.6714 8.54277 30.4715C8.71284 30.2716 8.9243 30.1109 9.16253 30.0007C9.40077 29.8906 9.6601 29.8334 9.92258 29.8333V29.8333Z",
    fill: "#C08552"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.e37ccbd336bd3e0140848242d850c15b.svg";
export { ForwardRef as ReactComponent };